import { apiRequest } from './client'
import type { SkillView, SkillVersionResult } from '../generated/directorSkillTypes'

const base = '/internal/director-skills'

export function listBuiltinSkills(): Promise<SkillView[]> {
  return apiRequest<SkillView[]>(base)
}

export async function readBuiltinSkill(skillId: string) {
  const path = `${base}/${encodeURIComponent(skillId)}`
  const [skill, versions] = await Promise.all([
    apiRequest<SkillView>(path),
    apiRequest<SkillView[]>(`${path}/versions`),
  ])
  if (skill.source !== 'builtin' || skill.skill_id !== skillId ||
      versions.some((version) => version.source !== 'builtin' ||
        version.skill_id !== skillId || !version.version_id || version.version === undefined)) {
    throw new Error('Built-in skill API returned inconsistent version metadata.')
  }
  return { skill, versions }
}

export function activateBuiltinSkill(skillId: string, versionId: string): Promise<SkillVersionResult> {
  return apiRequest<SkillVersionResult>(`${base}/${encodeURIComponent(skillId)}/activate`, {
    method: 'POST',
    body: JSON.stringify({ version_id: versionId } satisfies Pick<SkillVersionResult, 'version_id'>),
  })
}

export function setBuiltinSkillEnabled(skillId: string, enabled: boolean): Promise<SkillView> {
  return apiRequest<SkillView>(`${base}/${encodeURIComponent(skillId)}`, {
    method: 'PATCH',
    body: JSON.stringify({ enabled } satisfies Pick<SkillView, 'enabled'>),
  })
}
